import { gql } from "@apollo/client";

export const profileImagesUploadMutation = gql`
  mutation profileImagesUpload($image: Upload!, $type: String!) {
    profile_image_upload(image: $image, type: $type) {
      result {
        success
        errors {
          field
          message
        }
      }
      image {
        id
        srcset {
          crop_area_x1
          crop_area_x2
          crop_area_y1
          crop_area_y2
          height
          rotation
          type
          url
          width
        }
      }
    }
  }
`;
